import {Box, Tab, Tabs} from "@mui/material";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import TabEventDetails from "./sections/eventDetailTabs/TabEventDetails";
import TabActivity from "./sections/messagesAndActivity/TabActivity";
import TabCustomerRADetails from "./sections/customerAndRADetailsTab/TabCustomerRADetails";
import TabMessages from "./sections/messagesAndActivity/TabMessages";
import TabPanel from "../../component/TabPanel";

const TheftMisappropriationDetailsTab = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});

    const [activeTab, setActiveTab] = useState(0);


    function allyProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`
        };
    }

    const handleChangeTab = (_e: any, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={activeTab} onChange={handleChangeTab}>
                    <Tab label={t('tabs.eventDetails')} {...allyProps(0)}/>
                    <Tab label={t('tabs.customerDetails')}{...allyProps(0)}/>
                    <Tab label={t('tabs.messages')}{...allyProps(0)}/>
                    <Tab label={t('tabs.activity')} {...allyProps(0)}/>
                </Tabs>
            </Box>
            <TabPanel value={activeTab} index={0}>
                <TabEventDetails setTheftMisappropriate={props.setTheftMisappropriate} theftMisappropriate={props.theftMisappropriate}/>
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
                <TabCustomerRADetails id={props.id} rentalAgreement={props.theftMisappropriate?.rentalAgreement} plate={props.theftMisappropriate?.plate}  tenant={props.theftMisappropriate?.tenant}/>
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
                <TabMessages plate={props.theftMisappropriate?.plate}
                             eventTypeCode={props.theftMisappropriate?.eventType.eventTypeCode}
                             idTheftMisappropriation={props.theftMisappropriate?.id}
                             tenant={props.theftMisappropriate?.tenant}
                             dealer={props.theftMisappropriate?.dealer}
                />
            </TabPanel>
            <TabPanel value={activeTab} index={3}>
                <TabActivity setTheftMisappropriate={props.setTheftMisappropriate}
                             activityNotes={props.theftMisappropriate?.activityNotes}/>
            </TabPanel>
        </Box>
    );
}

export default TheftMisappropriationDetailsTab;